/**
 * Created by zqy on 2018/8/20 0020.
 */
export function parseTime(time, cFormat) {
  if(!time || time.length===0){
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else if(typeof  time==='string' && toInt(time)==0){
    try {
      if(new Date(time) != 'Invalid Date'){
        time=time.replace(/-/g,'/').replace('.','/').replace('.','/');
        date = new Date(time)
      }
    }catch (e) {
      return null
    }
  }
  else{
    date = new Date(time*1000)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function timestamp(time) {
  if(!time || time.length===0){
    return null
  }
  if (arguments.length === 0) {
    return null
  }
  //getTime()返回数值的单位是毫秒
  let dealTime = time.replace(/-/g,'/')
  let date = new Date(dealTime).getTime()/1000

  return date
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// 获取url参数
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/ig) != null) {
      len += 1
    } else { len += 0.5 }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined) return ''
    return encodeURIComponent(key) + '=' +
            encodeURIComponent(json[key])
  })).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach((property) => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function scrollTo(element, to, duration) {
  if (duration <= 0) return
  const difference = to - element.scrollTop
  const perTick = difference / duration * 10
  setTimeout(() => {
    console.log(new Date())
    element.scrollTop = element.scrollTop + perTick
    if (element.scrollTop === to) return
    scrollTo(element, to, duration - 10)
  }, 10)
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}
export function toInt(e){
  var n = e || 0;
  if("string"!= typeof n && "number"!=typeof n) n=0;
  return isNaN(n)?0:parseInt(n);
}
//字符串转浮点型
export function toFloat(e){
  var n = e || 0;
  if("string"!= typeof n && "number"!=typeof n) n=0;
  return isNaN(n)?0:parseFloat(n);
}
//制保留2位小数，如：2，会在2后面补上00.即2.00
export function toDecimal2(e){
  if(!e) return '0'
  var n = toFloat(e);
  var f = Math.round(n * 100) / 100;
  var s = f.toString();
  var rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
}
//删除json中value为空的key
export function deleteEmptyProperty(object){
  console.log(1111)
  for (var i in object) {
    var value = object[i];
    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        if (value.length == 0) {
          delete object[i];
          continue;
        }
      }
      this.deleteEmptyProperty(value);
      if (this.isEmpty(value)) {
        delete object[i];
      }
    } else {
      if (value === '' || value === null || value === undefined) {
        delete object[i];
      } else {
      }
    }
  }
}

/**
 * 去除对象中值为null、undefined、“”的字段
 */
export function removeEmptyField(obj) {
  var newObj = {};
  if(typeof obj == "string"){
      try{
        obj = JSON.parse(obj);
      }catch (e){
        return obj;
      }
  }
  if(obj instanceof Array){
      newObj = [];
  }
  if(obj instanceof Object){
      for(var key in obj){
          if(obj.hasOwnProperty(key) && obj[key] !== "" && obj[key] !== null && obj[key] !== undefined){
              if(obj[key] instanceof Object){
                  newObj[key] = removeEmptyField(obj[key]);
              }else if(typeof obj[key] == "string" && ((obj[key].indexOf("{") > -1 && obj[key].indexOf("}") > -1) || (obj[key].indexOf("[") > -1 && obj[key].indexOf("]") > -1))){
                  try{
                      var keyObj = JSON.parse(obj[key]);
                      if(keyObj instanceof Object){
                          newObj[key] = removeEmptyField(keyObj);
                      }
                  }catch (e){
                      newObj[key] = obj[key];
                  }
              }else{
                  newObj[key] = obj[key];
              }
          }
      }
  }
  return newObj;
}

function isEmpty(object) {
  for (var name in object) {
    return false;
  }
  return true;
}

/**
 * 处理对象参数值，排除对象参数值为”“、null、undefined，并返回一个新对象
 **/
export function dealObjectValue(obj){
  var param = {};
  if ( obj === null || obj === undefined || obj === "" ) return param;
  for ( var key in obj ){
    if(  obj[key] !== null && obj[key] !== undefined && obj[key] !== ""  ){
      param[key] = obj[key];
    }
    else if ( typeof obj[key] === "Object" ){
      param[key] = dealObjectValue(obj[key]);
    }
  }
  return param;
};

/*
 * 数组排序
 * @params {key} 排序字段
 * @params {desc} 是否降序
 * */
export function arrSortByKey(key,desc) {
  return function(a,b){
    if(desc){
      return (a[key] < b[key]) ? 1 : -1
    }else{
      return (a[key] > b[key]) ? 1 : -1
    }
    //return desc ? ~~(a[key] < b[key]) : ~~(a[key] > b[key]);
  }
}

/**
 * 日期格式
 * data: 日期 [String,Number]
 * format: 日期格式 [String] 默认：'y-m-d h:i:s'
 * 
 * 参考文章：
 * https://blog.csdn.net/jbguo/article/details/82802647
 * https://www.cnblogs.com/itjeff/p/10082109.html
 */
export function formatDate (data, format) {
  if (arguments.length == 0) {
    return null
  }
  if (!data || typeof data == 'string' && data.trim() == '') {
    return null
  }

  var time
  var tFormat = format || "y-m-d h:i:s"

  if (typeof data == 'number' || /^\d+$/.test(data)) {
    // 判断时间戳单位，统一单位为毫秒
    var timestamp = ('' + data).length < 11 ? data*1000 : data
    timestamp = parseInt(timestamp)
    time = new Date(timestamp)
  } else if (new Date(data) != 'Invalid Date') {
    time = new Date(data)
  } else {
    return null
  }

  var week = ['日', '一', '二', '三', '四', '五', '六']
  var date = {
    y: time.getFullYear(),
    m: time.getMonth() + 1,
    d: time.getDate(),
    h: time.getHours(),
    i: time.getMinutes(),
    s: time.getSeconds(),
    w: '星期' + week[time.getDay()],
  };

  var time_str = tFormat.replace(/(y|m|d|h|i|s|w)+/g, (result, key) => {
    var value = timeFormat( date[key] )
    return value || 0
  })

  function timeFormat(num) {
    return num < 10 ? '0' + num : num
  }

  return time_str
}

/**
 * 某天的开始时间戳
 * time 日期或时间戳
 * type 返回类型，0：时间戳 1：时间串 默认返回时间戳
 */
export function startUnix(time,type) {
  var curDate,timestamp
  if (time) {
    /**
     * 日期字符串有四种:
     * 1.YYYY-MM-DD　2000-01-01 01:01:01 | 2000-1-1 1:1:1
     * 2.MM-DD-YYYY　01-01-2000 01:01:01 | 1-1-2011 1:1:1
     * 3.YYYY/MM/DD　2000/01/01 01:01:01 | 2000/1/1 1:1:1
     * 4.MM/DD/YYYY　01/01/2000 01:01:01 | 1/1/2000 1:1:1
     * IE浏览器下不支持第一种格式，需要转换
     */
    curDate = new Date( formatDate(time).replace(/-/g,'/') ).toDateString()
  } else {
    // curDate = new Date().toDateString()
    return null
  }

  timestamp = Date.parse(curDate) / 1000

  if (type == 1) {
    return formatDate(timestamp)
  } else {
    return timestamp
  }
}

/**
 * 当天的结束时间戳
 * time 日期或时间戳
 * type 返回类型，0：时间戳 1：时间串 默认返回时间戳
 */
export function endUnix(time,type) {
  var curDate,timestamp
  if (time) {
    /**
     * 日期字符串有四种:
     * 1.YYYY-MM-DD　2000-01-01 01:01:01 | 2000-1-1 1:1:1
     * 2.MM-DD-YYYY　01-01-2000 01:01:01 | 1-1-2011 1:1:1
     * 3.YYYY/MM/DD　2000/01/01 01:01:01 | 2000/1/1 1:1:1
     * 4.MM/DD/YYYY　01/01/2000 01:01:01 | 1/1/2000 1:1:1
     * IE浏览器下不支持第一种格式，需要转换
     */
    curDate = new Date( formatDate(time).replace(/-/g,'/') ).toDateString()
  } else {
    // curDate = new Date().toDateString()
    return null
  }
  
  timestamp = Date.parse(curDate) / 1000 + 24 * 60 * 60 - 1

  if (type == 1) {
    return formatDate(timestamp)
  } else {
    return timestamp
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js